exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// C:/angular/aws-lex-web-ui-master/aws-lex-web-ui-master/node_modules/core-js/modules/_object-pie.js
// module id = ../../../node_modules/core-js/modules/_object-pie.js
// module chunks = 0